export default "/images/vendor/flag-icon-css/flags/1x1/tc.svg?0d16f864a483488586df2212e962475a";